import { Paper, Skeleton, Stack, Typography } from "@mui/material";

// Icons
import InfoIcon from "@mui/icons-material/InfoOutlined";

export default function TextIconMessage(props) {
	return (
		<Paper elevation={0} style={{ backgroundColor: "transparent" }} sx={props.sx}>
			{props.loading ? (
				<Stack direction={"row"} alignItems={"center"} spacing={0.5}>
					{props.icon && <Skeleton variant={"circular"} width={14} height={14} />}
					<Stack>
						<Skeleton variant={"text"} width={200} height={20} />
					</Stack>
				</Stack>
			) : (
				<>
					{props.showContent && (
						<Stack direction={"row"} alignItems={"center"} spacing={0.5}>
							{props.icon && <InfoIcon fontSize="1rem" sx={props.sxIcon} />}
							{props.title && (
								<Typography className={"regular-pt-sans-pro-narrow-label"} component={"span"}>
									{props.title}
								</Typography>
							)}
							{props.content && (
								<Typography className={"regular-pt-sans-pro-narrow-label"} component={"span"}>
									{props.content}
								</Typography>
							)}
						</Stack>
					)}
				</>
			)}
		</Paper>
	);
}

import PropTypes from "prop-types";
TextIconMessage.propTypes = {
	loading: PropTypes.bool,
	icon: PropTypes.bool,
	showContent: PropTypes.bool,
	title: PropTypes.string,
	content: PropTypes.string,
	sx: PropTypes.object,
	sxIcon: PropTypes.object,
  };